import React from "react";
import { Skeleton, TableCell, TableRow } from "@mui/material";

const FilasSkeleton = ({ columnas, filas = 4 }) =>
  Array.from({ length: filas }).map((_, i) => (
    <TableRow key={`skeleton-${i}`}>
      {Array.from({ length: columnas }).map((__, j) => (
        <TableCell key={j}><Skeleton variant="text" /></TableCell>
      ))}
    </TableRow>
  ));

export default FilasSkeleton;
